import styles from './list-view-item-separator.module.scss';

export function ListViewItemSeparator() {
  return <div className={styles.separator}></div>;
}
